import {
  EnvironmentOutlined,
  HeartOutlined,
  TrophyOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { DonorStatus } from 'gql/types';
import React from 'react';

export enum DonorStatusFilter {
  ActiveDonors = 'ActiveDonors',
  SingleDonors = 'SingleDonors',
  DoubleDonors = 'DoubleDonors',
  NewDonors = 'NewDonors',
  ExperiencedDonors = 'ExperiencedDonors',
  Active = 'Active',
  Pending = 'Pending',
  Approved = 'Approved',
  Archived = 'Archived',
  NotAccepted = 'NotAccepted',
  Trp = 'Trp',
  Retired = 'Retired',
  Affiliate = 'Affiliate',
}

export const FILTER_CONFIG: Record<
  DonorStatusFilter,
  {
    translationKey: string;
    color: string;
    icon: React.ComponentType;
    donorStatuses: DonorStatus[];
  }
> = {
  [DonorStatusFilter.ActiveDonors]: {
    translationKey: 'activeDonors',
    color: '#3f8600',
    icon: UserOutlined,
    donorStatuses: [DonorStatus.Active],
  },
  [DonorStatusFilter.SingleDonors]: {
    translationKey: 'singleDonors',
    color: '#cf1322',
    icon: HeartOutlined,
    donorStatuses: [DonorStatus.Active],
  },
  [DonorStatusFilter.DoubleDonors]: {
    translationKey: 'doubleDonors',
    color: '#1890ff',
    icon: TrophyOutlined,
    donorStatuses: [DonorStatus.Active],
  },

  [DonorStatusFilter.NewDonors]: {
    translationKey: 'newDonors',
    color: '#722ed1',
    icon: UserOutlined,
    donorStatuses: [DonorStatus.Active],
  },
  [DonorStatusFilter.ExperiencedDonors]: {
    translationKey: 'experiencedDonors',
    color: '#eb2f96',
    icon: HeartOutlined,
    donorStatuses: [DonorStatus.Active],
  },

  [DonorStatusFilter.Active]: {
    translationKey: 'activeStatus',
    color: '#52c41a',
    icon: UserOutlined,
    donorStatuses: [DonorStatus.Active],
  },
  [DonorStatusFilter.Pending]: {
    translationKey: 'pendingStatus',
    color: '#fa8c16',
    icon: HeartOutlined,
    donorStatuses: [DonorStatus.Pending],
  },
  [DonorStatusFilter.Approved]: {
    translationKey: 'approvedStatus',
    color: '#1890ff',
    icon: TrophyOutlined,
    donorStatuses: [DonorStatus.Approved],
  },
  [DonorStatusFilter.Archived]: {
    translationKey: 'archivedStatus',
    color: '#722ed1',
    icon: EnvironmentOutlined,
    donorStatuses: [DonorStatus.Archived],
  },
  [DonorStatusFilter.NotAccepted]: {
    translationKey: 'notAcceptedStatus',
    color: '#eb2f96',
    icon: UserOutlined,
    donorStatuses: [DonorStatus.NotAccepted],
  },
  [DonorStatusFilter.Trp]: {
    translationKey: 'trpStatus',
    color: '#f5222d',
    icon: HeartOutlined,
    donorStatuses: [DonorStatus.Trp],
  },
  [DonorStatusFilter.Retired]: {
    translationKey: 'retiredStatus',
    color: '#fa541c',
    icon: TrophyOutlined,
    donorStatuses: [DonorStatus.Retired],
  },
  [DonorStatusFilter.Affiliate]: {
    translationKey: 'affiliateStatus',
    color: '#13c2c2',
    icon: EnvironmentOutlined,
    donorStatuses: [DonorStatus.Affiliate],
  },
};

export const DONOR_TYPE_KEYS = [
  DonorStatusFilter.ActiveDonors,
  DonorStatusFilter.SingleDonors,
  DonorStatusFilter.DoubleDonors,
];
export const EXPERIENCE_KEYS = [
  DonorStatusFilter.NewDonors,
  DonorStatusFilter.ExperiencedDonors,
];
export const STATUS_KEYS = [
  DonorStatusFilter.Active,
  DonorStatusFilter.Pending,
  DonorStatusFilter.Approved,
  DonorStatusFilter.Archived,
  DonorStatusFilter.NotAccepted,
  DonorStatusFilter.Trp,
  DonorStatusFilter.Retired,
  DonorStatusFilter.Affiliate,
];

export const DONOR_TYPE_COLORS = [
  FILTER_CONFIG[DonorStatusFilter.SingleDonors].color,
  FILTER_CONFIG[DonorStatusFilter.DoubleDonors].color,
];
export const STATUS_CHART_COLORS = STATUS_KEYS.map(
  (key) => FILTER_CONFIG[key].color
);

export const THREE_MONTHS_MS = 3 * 30 * 24 * 60 * 60 * 1000;
export const DOUBLE_DONOR_ML_THRESHOLD = 420;
